/* global VXConfig */
import { toTagGroupSlug } from './TagGroupSlug';

const VIDEO_SEARCH_ROUTES = {
	de: '/de/suche/videos/:searchPattern/',
	en: '/en/search/videos/:searchPattern/',
	es: '/es/buscar/videos/:searchPattern/',
};

const NEW_ACTORS_ROUTES = {
	de: '/de/neue-girls/',
	en: '/en/new-girls/',
	es: '/es/nuevas-chicas/',
};

const ACTOR_PROFILE_ABOUT_ME_ROUTES = {
	de: '/de/amateur/:actorName/ueber-mich/',
	en: '/en/amateur/:actorName/about-me/',
	es: '/es/amateur/:actorName/acerca-de-mi/',
};

const ACTOR_PROFILE_VIDEOS_ROUTES = {
	de: '/de/amateur/:actorName/videos/',
	en: '/en/amateur/:actorName/videos/',
	es: '/es/amateur/:actorName/videos/',
};

const ACTOR_PROFILE_VIDEOS_TAG_GROUP = {
	de: '/de/amateur/:actorName/videos/tag/:tagGroup/',
	en: '/en/amateur/:actorName/videos/tag/:tagGroup/',
	es: '/es/amateur/:actorName/videos/tag/:tagGroup/',
};

const ACTOR_PROFILE_PHOTOALBUM_DETAIL = {
	de: '/de/amateur/:actorName/fotos/:albumId/',
	en: '/en/amateur/:actorName/pictures/:albumId/',
	es: '/es/amateur/:actorName/fotos/:albumId/',
};

const ACTOR_PROFILE_LIVE_SHOW_ROUTES = {
	de: '/de/amateur/:actorName/live-show/',
	en: '/en/amateur/:actorName/live-show/',
	es: '/es/amateur/:actorName/show-en-vivo/',
};

const ACTOR_PROFILE_TOP_CAMS_ROUTES = {
	de: '/de/amateur/:actorName/top-cams/',
	en: '/en/amateur/:actorName/top-cams/',
	es: '/es/amateur/:actorName/top-cams/',
};

const FREE_CHAT_ROUTES = {
	de: '/de/gratis-chat/',
	en: '/en/free-chat/',
	es: '/es/chat-gratis/',
};

const CAMS_ROUTES = {
	de: '/de/cams/',
	en: '/en/cams/',
	es: '/es/cams/',
};

const CATEGORY_ROUTES = {
	de: '/de/kategorien/:categorySlug/',
	en: '/en/categories/:categorySlug/',
	es: '/es/categorias/:categorySlug/',
};

const VIDEOS_FREE_ROUTES = {
	de: '/de/videos/gratis-clips/',
	en: '/en/videos/free-clips/',
	es: '/es/videos/clips-gratis/',
};

const VIDEOS_TRENDING_ROUTES = {
	de: '/de/videos/video-trends/',
	en: '/en/videos/video-trends/',
	es: '/es/videos/video-tendencias/',
};

const VIDEOS_SALE_ROUTES = {
	de: '/de/videos/on-sale/',
	en: '/en/videos/on-sale/',
	es: '/es/videos/en-oferta/',
};

const VIDEOS_NEW_ROUTES = {
	de: '/de/videos/neue-videos/',
	en: '/en/videos/new-videos/',
	es: '/es/videos/nuevos-videos/',
};

const MESSENGER_ROUTES = {
	de: '/de/messenger/',
	en: '/en/messenger/',
	es: '/es/mensajes/',
};

const VIDEOS_MEDIATHEK_ROUTES = {
	de: '/de/videos/mediathek/',
	en: '/en/videos/media/',
	es: '/es/videos/media/',
};

const DAILY_BONUS_ROUTES = {
	de: '/de/deal-des-tages/',
	en: '/en/daily-deals/',
	es: '/es/ofertas-diarias/',
};

const CONTEST_ROUTES = {
	de: '/de/wettbewerbe/',
	en: '/en/contests/',
	es: '/es/concursos/',
	nl: '/nl/wedstrijden/',
};

const CONTEST_ROUTES_DETAIL = {
	de: '/de/wettbewerbe/:id/',
	en: '/en/contests/:id/',
	es: '/es/concursos/:id/',
	nl: '/nl/wedstrijden/:id/',
};

const CONTEST_ROUTES_DETAIL_TOP10 = {
	de: '/de/wettbewerbe/:id/top10/',
	en: '/en/contests/:id/top10/',
	es: '/es/concursos/:id/top10/',
	nl: '/nl/wedstrijden/:id/top10/',
};

const CONTEST_ROUTES_DETAIL_VOTED = {
	de: '/de/wettbewerbe/:id/bewertet/',
	en: '/en/contests/:id/voted/',
	es: '/es/concursos/:id/votados/',
	nl: '/nl/wedstrijden/:id/rated/',
};

const CONTEST_ROUTES_DETAIL_UNVOTED = {
	de: '/de/wettbewerbe/:id/unbewertet/',
	en: '/en/contests/:id/unvoted/',
	es: '/es/concursos/:id/no-votados/',
	nl: '/nl/wedstrijden/:id/ongewogen/',
};

const HOMEPAGE_ROUTES = {
	de: '/',
	en: '/en/',
	es: '/es/',
};

const MEDIA_SERIES_ROUTES = {
	de: '/de/videos/mediathek/:series/',
	en: '/en/videos/media/:series/',
	es: '/es/videos/media/:series/',
};

const MEDIA_KEY_ROUTES = {
	de: '/de/videos/mediathek/:key/videos/',
	en: '/en/videos/media/:key/videos/',
	es: '/es/videos/media/:key/videos/',
};

const VIDEOS_INDEX_ROUTES = {
	de: '/de/videos/',
	en: '/en/videos/',
	es: '/es/videos/',
};

const VIDEOS_ALL_ROUTES = {
	de: '/de/videos/alle-videos/',
	en: '/en/videos/all-videos/',
	es: '/es/videos/todos-los-videos/',
};

const ACTOR_PROFILE_ROUTES = {
	de: '/de/amateur/:actorName/',
	en: '/en/amateur/:actorName/',
	es: '/es/amateur/:actorName/',
};

const ACTOR_PROFILE_VIDEOS_CLASSIC_ROUTES = {
	de: '/de/amateur/:actorName/videos/classic/',
	en: '/en/amateur/:actorName/videos/classic/',
	es: '/es/amateur/:actorName/videos/classic/',
};

const VIP30_ROUTES = {
	de: '/de/videos/vip-videos/',
	en: '/en/videos/vip-videos/',
	es: '/es/videos/vip-videos/',
};

const VIPCLUB_ROUTES = {
	de: '/de/vipclub/',
	en: '/en/vipclub/',
	es: '/es/vipclub/',
};

const EASTER_URL = {
	de: '/de/magazin/ostern/',
	en: '/en/magazine/easter/',
	es: '/es/magazine/easter/',
};

const VIDEO_STARS_ROUTES = {
	de: '/de/videos/stars/',
	en: '/en/videos/stars/',
	es: '/es/videos/estrellas/',
};

const VIDEOS_MEDIATHEK_SERIES_OVERVIEW_ROUTES = {
	de: '/de/videos/mediathek/serien/',
	en: '/en/videos/media/series/',
	es: '/es/videos/media/series/',
};

const WET_N_WILD_GAME = {
	de: '/de/magazin/wetnwildgame/',
	en: '/en/magazine/wetnwildgame/',
	es: '/es/magazine/wetnwildgame/',
};

const ADVENT_CALENDAR_ROUTES = {
	de: '/de/magazin/adventskalender/',
	en: '/en/magazine/advent-calendar/',
	es: '/es/magazine/calendario-de-adviento/',
};

const MY_VISIT_X_SPINWHEEL = {
	de: '/de/meinvisitx/gluecksrad/',
	en: '/en/myvisitx/spinwheel/',
	es: '/es/mivisitx/ruleta-de-la-fortuna/',
};

const MY_VISIT_X = {
	de: '/de/meinvisitx/',
	en: '/en/myvisitx/',
	es: '/es/mivisitx/',
};

const MY_VISIT_X_PROFILE = {
	de: '/de/meinvisitx/profil/',
	en: '/en/myvisitx/profile/',
	es: '/es/mivisitx/perfil',
};

const MY_VISITX_VIDEOCHATS = {
	de: '/de/meinvisitx/meine-videochats/',
	en: '/en/myvisitx/my-videochats/',
	es: '/es/mivisitx/my-videochats/',
};

const MY_VISIT_X_MEDIATHEK = {
	de: '/de/meinvisitx/mediathek/',
	en: '/en/myvisitx/mediathek/',
	es: '/es/mivisitx/mediathek/',
};

const MY_VISIT_X_MEDIATHEK_PHOTOS = {
	de: '/de/meinvisitx/mediathek/photos/',
	en: '/en/myvisitx/mediathek/photos/',
	es: '/es/mivisitx/mediathek/photos/',
};

const MY_VISIT_X_MEDIATHEK_VIDEOS = {
	de: '/de/meinvisitx/mediathek/videos/',
	en: '/en/myvisitx/mediathek/videos/',
	es: '/es/mivisitx/mediathek/videos/',
};

const MY_VISIT_X_ACHIEVEMENT = {
	de: '/de/meinvisitx/achievement/',
	en: '/en/myvisitx/achievement/',
	es: '/es/mivisitx/achievement/',
};

const MY_VISIT_X_ACHIEVEMENT_COLLECTION = {
	de: '/de/meinvisitx/achievement/sammlung/',
	en: '/en/myvisitx/achievement/collection/',
	es: '/es/mivisitx/achievement/collection/',
};

const MY_VISIT_X_BENEFITS = {
	de: '/de/meinvisitx/benefits/',
	en: '/en/myvisitx/benefits/',
	es: '/es/mivisitx/beneficios/',
};

const CAM_SHOWS = {
	de: '/de/cam-shows/',
	en: '/en/cam-shows/',
	es: '/es/cam-shows/',
};

const TERMS_OF_SERVICE = {
	de: '/de/agb/',
	en: '/en/terms-of-service/',
	es: '/es/terminos-de-servicio/',
};

const DATA_PROTECTION = {
	de: '/de/datenschutz/',
	en: '/en/data-protection/',
	es: '/es/proteccion-de-datos/',
};

const FEED = {
	de: '/de/feed/',
	en: '/en/feed/',
	es: '/es/feed/',
};

const GOLDRUSH = {
	de: '/de/magazin/goldrausch/',
	en: '/en/magazine/goldrush/',
	es: '/es/magazine/goldrush/',
};

const KICK_IT = {
	de: '/de/magazin/kick-it/',
	en: '/en/magazine/kick-it/',
	es: '/es/magazine/kick-it/',
};

const FAVORITES = {
	de: '/de/meinvisitx/favoriten-cams/',
	en: '/en/myvisitx/favorite-cams/',
	es: '/es/mivisitx/cams-favoritas/',
};

const FAVORITE_VIDEOS = {
	de: '/de/meinvisitx/favoriten-videos/',
	en: '/en/myvisitx/favorite-videos/',
	es: '/es/mivisitx/favoriten-videos/',
};

const ROSENRAUSCH = {
	de: '/de/rosenrausch/',
	en: '/en/highonrose/',
	es: '/es/frenesi-de-rosas/',
};

function getBaseRouteForCurrentLanguage(routesByLanguage) {
	return routesByLanguage[VXConfig.language] || routesByLanguage.en;
}

export default {
	buildVideoSearchUrl(searchTerm) {
		return getBaseRouteForCurrentLanguage(VIDEO_SEARCH_ROUTES).replace(':searchPattern', searchTerm);
	},
	buildNewActorsUrl() {
		return getBaseRouteForCurrentLanguage(NEW_ACTORS_ROUTES);
	},
	buildActorProfileAboutMeUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_ABOUT_ME_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildActorProfileVideosUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_VIDEOS_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildActorProfileLiveShowUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_LIVE_SHOW_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildActorProfileTopCamsUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_TOP_CAMS_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildFreeChatRoute() {
		return getBaseRouteForCurrentLanguage(FREE_CHAT_ROUTES);
	},
	buildCamsRoute() {
		return getBaseRouteForCurrentLanguage(CAMS_ROUTES);
	},
	buildCategoryRoute(category) {
		return getBaseRouteForCurrentLanguage(CATEGORY_ROUTES).replace(':categorySlug', category);
	},
	buildFreeVideosRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_FREE_ROUTES);
	},
	buildVideosTrendingRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_TRENDING_ROUTES);
	},
	buildVideosSaleRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_SALE_ROUTES);
	},
	buildVideosNewRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_NEW_ROUTES);
	},
	buildMessengerRoute() {
		return getBaseRouteForCurrentLanguage(MESSENGER_ROUTES);
	},
	buildVideosMediathekRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_MEDIATHEK_ROUTES);
	},
	buildTvLivestreamRoute() {
		return this.buildVideosMediathekRoute();
	},
	buildTvPremiumLivestreamRoute() {
		return this.buildVideosMediathekRoute();
	},
	buildDailyBonusRoute() {
		return getBaseRouteForCurrentLanguage(DAILY_BONUS_ROUTES);
	},
	buildContestRoute() {
		return getBaseRouteForCurrentLanguage(CONTEST_ROUTES);
	},
	buildContestDetailRoute(id) {
		return getBaseRouteForCurrentLanguage(CONTEST_ROUTES_DETAIL).replace(':id', id);
	},
	buildContestDetailTop10Route(id) {
		return getBaseRouteForCurrentLanguage(CONTEST_ROUTES_DETAIL_TOP10).replace(':id', id);
	},
	buildContestDetailVotedRoute(id) {
		return getBaseRouteForCurrentLanguage(CONTEST_ROUTES_DETAIL_VOTED).replace(':id', id);
	},
	buildContestDetailUnvotedRoute(id) {
		return getBaseRouteForCurrentLanguage(CONTEST_ROUTES_DETAIL_UNVOTED).replace(':id', id);
	},
	buildHomepageRoute() {
		return getBaseRouteForCurrentLanguage(HOMEPAGE_ROUTES);
	},
	buildMediaSeriesRoute(series) {
		return getBaseRouteForCurrentLanguage(MEDIA_SERIES_ROUTES).replace(':series', series);
	},
	buildMediaKeyRoute(key) {
		return getBaseRouteForCurrentLanguage(MEDIA_KEY_ROUTES).replace(':key', key);
	},
	buildVideoIndexRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_INDEX_ROUTES);
	},
	buildVideoAllRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_ALL_ROUTES);
	},
	buildActorProfileUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildActorVideoClassicUrl(actorName) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_VIDEOS_CLASSIC_ROUTES).replace(':actorName', actorName.toLowerCase());
	},
	buildVIP30Url() {
		return getBaseRouteForCurrentLanguage(VIP30_ROUTES);
	},
	buildVIPClubUrl() {
		return getBaseRouteForCurrentLanguage(VIPCLUB_ROUTES);
	},
	buildEasterRoute() {
		return getBaseRouteForCurrentLanguage(EASTER_URL);
	},
	buildVideoStarsRoute() {
		return getBaseRouteForCurrentLanguage(VIDEO_STARS_ROUTES);
	},
	buildTVSeriesOverviewRoute() {
		return getBaseRouteForCurrentLanguage(VIDEOS_MEDIATHEK_SERIES_OVERVIEW_ROUTES);
	},
	buildWetNWildRoute() {
		return getBaseRouteForCurrentLanguage(WET_N_WILD_GAME);
	},
	buildAdventCalendarRoute() {
		return getBaseRouteForCurrentLanguage(ADVENT_CALENDAR_ROUTES);
	},
	buildMyVisitXRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X);
	},
	buildMyVisitXProfileRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_PROFILE);
	},
	buildMyVisitXVideoChatsRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISITX_VIDEOCHATS);
	},
	buildMyVisitXMediathekRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_MEDIATHEK);
	},
	buildMyVisitXMediathekPhotosRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_MEDIATHEK_PHOTOS);
	},
	buildMyVisitXMediathekVideosRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_MEDIATHEK_VIDEOS);
	},
	buildMyVisitXAchievementRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_ACHIEVEMENT);
	},
	buildMyVisitXAchievementCollectionRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_ACHIEVEMENT_COLLECTION);
	},
	buildMyVisitXSpinwheelRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_SPINWHEEL);
	},
	buildGoldrushRoute() {
		return getBaseRouteForCurrentLanguage(GOLDRUSH);
	},
	buildKickItRoute() {
		return getBaseRouteForCurrentLanguage(KICK_IT);
	},
	buildMyVisitXBenefitsRoute() {
		return getBaseRouteForCurrentLanguage(MY_VISIT_X_BENEFITS);
	},
	buildCamShowsRoute() {
		return getBaseRouteForCurrentLanguage(CAM_SHOWS);
	},
	buildActorProfileVideosTagGroupRoute(actorName, tagGroup) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_VIDEOS_TAG_GROUP)
			.replace(':actorName', actorName)
			.replace(':tagGroup', toTagGroupSlug(tagGroup));
	},
	buildActorProfilePictureDetailRoute(actorName, albumId) {
		return getBaseRouteForCurrentLanguage(ACTOR_PROFILE_PHOTOALBUM_DETAIL)
			.replace(':actorName', actorName.toLowerCase())
			.replace(':albumId', albumId);
	},
	buildFeedRoute() {
		return getBaseRouteForCurrentLanguage(FEED);
	},
	buildTermsOfServiceRoute() {
		return getBaseRouteForCurrentLanguage(TERMS_OF_SERVICE);
	},
	buildDataProtectionRoute() {
		return getBaseRouteForCurrentLanguage(DATA_PROTECTION);
	},
	buildFavoritesRoute() {
		return getBaseRouteForCurrentLanguage(FAVORITES);
	},
	buildFavoriteVideosRoute() {
		return getBaseRouteForCurrentLanguage(FAVORITE_VIDEOS);
	},
	buildRosenrauschRoute() {
		return getBaseRouteForCurrentLanguage(ROSENRAUSCH);
	},
};

export { getBaseRouteForCurrentLanguage };
